import { Component, Input, Output, OnInit, EventEmitter, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Tooltip } from '../core/tooltip/Tooltip';

const iconTypes = {
  back: { fa: 'fa-chevron-left' },
  info: { fa: 'fa-info' },
  edit: { fa: 'fa-pencil' },
  annotate: { fa: 'fa-pencil' },
  save: { fa: 'fa-save' },
  cancel: { fa: 'fa-remove' },
  close: { fa: 'fa-close' },
  create: { fa: 'fa-plus' },
  next: { fa: 'fa-chevron-right' },
  prev: { fa: 'fa-chevron-left' },
  list: { fa: 'fa-list' },
  submit: { fa: 'fa-upload' },
  discussion: { fa: 'fa-comments' },
  delete: { fa: 'fa-trash' },
  approve: { fa: 'fa-thumbs-up' },
  unapprove: { fa: 'fa-thumbs-down' },
  return: { fa: 'fa-arrow-left' }
} as const;

type IconType = keyof typeof iconTypes;

@Component({
    selector: 'app-gphc-icon',
    templateUrl: './gphc-icon.component.html',
    styleUrls: ['./gphc-icon.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class GphcIconComponent implements OnInit {

  @HostBinding('tabindex') tabindex = -1;
  @Input() iconType!: IconType;
  @Input() label!: string;
  position = 'absolute';
  @Input() set static(value: boolean) {
    if (value) {
      this.position = 'static';
    }
  }
  @Input() description = '';
  @Input() small = false;
  @Input() active = false;
  @Input() primary = false;
  offsetPixelsTop: string | undefined;
  offsetPixelsRight: string | undefined = '-10px';
  offsetPixelsLeft: string | undefined;
  @Input() disabled = false;
  @Input() showLabel = true;
  @Input() showLabelAlways = false;
  @Input() tooltip!: Tooltip;

  @Input('offset') set offsetRight(value: number | string) {
    if (value === 'none') {
      this.offsetPixelsRight = undefined;
    } else {
      this.offsetPixelsRight = value + 'px';
    }
  }
  @Input('offsetLeft') set offsetLeft(value: number | string) {
    if (value === 'none') {
      this.offsetPixelsLeft = undefined;
    } else {
      this.offsetPixelsLeft = value + 'px';
    }
  }
  @Input('offsetTop') set offsetTop(value: number | string) {
    if (value === 'none') {
      this.offsetPixelsTop = undefined;
    } else {
      this.offsetPixelsTop = value + 'px';
    }
  }

  @Output() click = new EventEmitter<MouseEvent>();


  iconTypes = iconTypes;

  constructor() { }

  ngOnInit() {
    if (this.iconType === 'info' || this.iconType === 'create') {
      this.showLabel = false;
    }
  }

  onClick($event: MouseEvent) {
    $event.stopPropagation();
    this.click.emit($event);
  }
  onKeyupEnter($event: KeyboardEvent) {
    $event.stopPropagation();
  }
  onKeydownEnter($event: KeyboardEvent) {
    $event.stopPropagation();
  }

}
